import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const wrap = css`
  margin: ${size[80]} auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: ${size[48]};
  padding: ${size[20]};
  max-width: ${width.container.large};

  ${breakpoint.up('smMd')} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`

export const heading = css`
  text-align: center;

  ${breakpoint.up('smMd')} {
    text-align: start;
  }
`

export const title = (theme: Theme) => css`
  color: ${theme.palette.primary.mainContrast};
  font-weight: 700;
  font-size: ${pxToRem(32)};
  margin-bottom: ${size[40]};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
    margin-bottom: ${size[48]};
  }
`

export const desc = (theme: Theme) => css`
  color: ${theme.palette.text.title};
  font-size: ${pxToRem(16)};
  margin-bottom: ${size[40]};
  line-height: ${pxToRem(24)};

  ${breakpoint.up('smMd')} {
    margin-bottom: ${size[48]};
  }
`

export const cta = css`
  ${breakpoint.up('smMd')} {
    margin-bottom: ${size[48]};
  }
`

export const qr = css`
  display: none;

  ${breakpoint.up('smMd')} {
    display: flex;
    width: 100%;
  }
`

export const lists = (theme: Theme) => css`
  border-top: 1px solid ${theme.palette.primary.lowContrast};
  padding-top: ${size[48]};
  position: relative;

  ${breakpoint.up('smMd')} {
    border-top: none;
    padding-top: 0;
    border-inline-start: 1px solid ${theme.palette.primary.lowContrast};
    padding-inline-start: ${size[48]};
  }
`

export const link = (theme: Theme) => css`
  text-decoration: none;
  display: block;
  color: ${theme.palette.tertiary.upperMediumContrast};
  font-weight: 400;
  line-height: 1.5rem;
  transition: color 200ms ease-in;
  margin-bottom: ${size[48]};

  &:last-of-type {
    margin-bottom: 0;
  }

  &:hover {
    color: ${theme.palette.text.title};

    span {
      color: ${theme.palette.primary.mainContrast};
    }
  }

  ${breakpoint.up('smMd')} {
    color: ${theme.palette.ghost.mediumContrast};
  }
`

export const linkHeadline = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  color: ${theme.palette.primary.mainContrast};
  font-weight: 700;
  font-size: ${pxToRem(22)};
  margin-bottom: ${size[8]};
  transition: inherit;
`

export const colTitle = (theme: Theme) => css`
  padding-bottom: ${size[40]};
  text-transform: uppercase;
  font-size: ${pxToRem(22)};
  color: ${theme.palette.secondary.mainContrast};

  ${breakpoint.up('smMd')} {
    position: absolute;
    top: -${size[80]};
    padding-bottom: 0;
  }
`

export const badge = (theme: Theme) => css`
  color: ${theme.palette.primary.mainContrast};
  font-weight: 400;
  text-transform: uppercase;
  font-size: ${pxToRem(14)};
`

export const stores = (theme: Theme) => css`
  justify-content: center;
  gap: ${size[8]};
  padding: ${size[12]};
  padding-top: ${size[8]};
  position: relative;
  top: -${size[8]};
  border-radius: 0 0 ${theme.borderRadius.md} ${theme.borderRadius.md};

  display: none;

  ${breakpoint.up('smMd')} {
    display: flex;
  }
`
